import { render, staticRenderFns } from "./UserAccount.vue?vue&type=template&id=6ecf3afc&scoped=true&"
import script from "./UserAccount.vue?vue&type=script&lang=ts&"
export * from "./UserAccount.vue?vue&type=script&lang=ts&"
import style0 from "./User.scss?vue&type=style&index=0&id=6ecf3afc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecf3afc",
  null
  
)

export default component.exports